import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/query/react'
import type { AxiosRequestConfig } from 'axios'

import http, { BASE_URL, CustomAxiosRequestConfig } from '@/config/http/http'
import { IError, shapeError } from '@/config/http/http.helpers'
import history from '@/config/router/history'
import { PATHS } from '@/config/router/routes'
import { removeFromLocalStorage } from '@/services/localStorage'

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '' }
  ): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
      noAuth?: boolean
      skipAuth?: boolean
    },
    unknown,
    IError
  > =>
  async ({ url, method, data, params, headers, skipAuth, noAuth }) => {
    try {
      const result = await http({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
        skipAuth,
        noAuth
      } as CustomAxiosRequestConfig)
      return { data: result.data }
    } catch (axiosError) {
      const error = shapeError(axiosError)
      if ((error.status && error.status === '401') || error.status === '403') {
        removeFromLocalStorage('token')
        history.push(PATHS.LOGIN)
      }
      return {
        error
      }
    }
  }

export const rootApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: [
    'Orders',
    'Menu',
    'Performance',
    'Account',
    'Offers',
    'CartDiscount',
    'BuyXGetY'
  ],
  endpoints(build) {
    return {
      query: build.query({ query: () => ({ url: '/query', method: 'get' }) }),
      mutation: build.mutation({
        query: () => ({ url: '/mutation', method: 'post' })
      })
    }
  }
})
